import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import api from '../../../connector/api';

export default function TermModal({ term, onClose, onSuccess }) {
    const [name, setName] = useState('');
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        if (term) {
            setName(term.name || '');
        } else {
            setName('');
        }
    }, [term]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);

        try {
            if (term?.id) {
                await api.put(`/terms/${term.id}/`, { name });
                toast.success("Term updated successfully.");
            } else {
                await api.post('/terms/', { name });
                toast.success("Term created successfully.");
            }
            onSuccess();
        } catch (err) {
            console.error("Failed to save term:", err);
            toast.error("Failed to save term.");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="fixed inset-0 w-screen h-screen z-50 flex items-center justify-center p-4 bg-black/40 backdrop-blur-xs">
            <div className="bg-white border border-zinc-200 rounded-lg max-w-sm w-full shadow-xl p-6 space-y-4">
                <div className="flex items-center justify-between border-b border-zinc-100 pb-3">
                    <h3 className="text-sm font-bold text-zinc-900">
                        {term ? 'Edit Term' : 'Add New Term'}
                    </h3>
                    <button onClick={onClose} className="text-zinc-400 hover:text-zinc-600 text-xs">
                        ✕
                    </button>
                </div>

                <form onSubmit={handleSubmit} className="space-y-4">
                    <div className="space-y-1">
                        <label className="text-xs font-medium text-zinc-700 block">Term Name</label>
                        <input
                            type="text"
                            placeholder="e.g. Semester 1, Winter Term"
                            className="w-full text-xs text-zinc-900 bg-zinc-50 border border-zinc-200 rounded-lg px-3 py-2 outline-none focus:border-blue-500 focus:bg-white transition-colors"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            required
                        />
                    </div>

                    <div className="flex justify-end gap-2 pt-2">
                        <button
                            type="button"
                            onClick={onClose}
                            className="px-3 py-1.5 text-xs font-medium text-zinc-600 bg-zinc-100 hover:bg-zinc-200 rounded-lg transition-colors"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            disabled={submitting}
                            className="px-3 py-1.5 text-xs font-semibold text-white bg-blue-600 hover:bg-blue-700 rounded-lg transition-colors shadow-sm disabled:opacity-50"
                        >
                            {submitting ? "Saving..." : term ? "Update Term" : "Create Term"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}